import { render } from "./privacy.vue?vue&type=template&id=351a43c5&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=351a43c5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351a43c5"]])

export default __exports__